exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.VueSplitter-Container-item {\n  height: 100%;\n  width: 100%;\n  border: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n}\n.VueSplitter-Container-horizontal {\n  flex-direction: column;\n}\n.VueSplitter-Container-vertical {\n  flex-direction: row;\n}\n", ""]);

// exports
exports.locals = {
	"item": "VueSplitter-Container-item",
	"horizontal": "VueSplitter-Container-horizontal",
	"vertical": "VueSplitter-Container-vertical"
};